/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ExpiresInputs */

const en_entity_expires = /** @type {(inputs: Entity_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

const de_entity_expires = /** @type {(inputs: Entity_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablaufdatum`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Entity_ExpiresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_expires = /** @type {((inputs?: Entity_ExpiresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ExpiresInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_expires(inputs)
	return de_entity_expires(inputs)
});